import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { AdditionalService } from "@/types/generated/ExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useAdditionalServicesMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["additional-services-masterdata"],
    queryFn: () => experienceMasterDataApi.getPremades("additional-services", { language_code: "en" }),
    select: ({ data }) => data as AdditionalService[],
  });
}
